import { css } from 'styled-components';

export const flex = (direction = 'row') => css`
  display: flex;
  flex-direction: ${direction};
`;
export const flexEnd = (direction = 'row') => css`
  ${flex(direction)};
  justify-content: flex-end;
`;

export const flexBetween = (direction = 'row') => css`
  ${flex(direction)};
  justify-content: space-between;
`;
export const flexBaseline = (direction = 'row') => css`
  ${flex(direction)};
  align-items: baseline;
`;
export const flexAround = (direction = 'row') => css`
  ${flex(direction)};
  justify-content: space-around;
`;
export const flexEvenly = (direction = 'row') => css`
  ${flex(direction)};
  justify-content: space-evenly;
`;
export const flexCenter = (direction = 'row') => css`
  ${flex(direction)};
  align-items: center;
  justify-content: center;
`;
export const flexJustifyCenter = (direction = 'row') => css`
  ${flex(direction)};
  justify-content: center;
`;

export const flexAlignCenter = (direction = 'row') => css`
  ${flex(direction)};
  align-items: center;
`;

export const verticalCenter = () => css`
  display: flex;
  align-items: center;
`;
export const twoLineEllipsis = () => css`
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
`;
export const backgroundCommon = (fit = 'cover') => css`
  background-repeat: no-repeat;
  background-position: center;
  background-size: ${fit};
`;

export const absoluteContent = () => css`
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
`;
export const absoluteCenter = () => css`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
`;
export const pointer = () => css`
  cursor: pointer;
`;
export const icon = () => css`
  font-size: var(--font-size-lg);
  color: var(--primary-color);
`;
export const autoFillGrid = (width: number, rowGap: number, columnGap: number) => css`
  display: grid;
  grid-row-gap: ${rowGap}px;
  grid-column-gap: ${columnGap}px;
  grid-template-columns: repeat(auto-fill, ${width}px);
`;
export const fullFillGrid = (count: number, rowGap: number, columnGap: number) => css`
  display: grid;
  grid-row-gap: ${rowGap}px;
  grid-column-gap: ${columnGap}px;
  grid-template-columns: repeat(${count}, 1fr);
  justify-items: stretch;
`;

export const scrollbarNone = () => css`
  overflow: scroll;
  scrollbar-width: none; /* Firefox */
  -ms-overflow-style: none; /* Internet Explorer 10+ */

  &::-webkit-scrollbar {
    display: none; /* Safari and Chrome */
  }
`;
export const scrollbarSlim = () => css`
  overflow: auto;
  &::-webkit-scrollbar {
    width: 5px;
    height: 5px;
  }
  &::-webkit-scrollbar-thumb {
    border-radius: 1em;
    background-color: rgba(50, 50, 50, 0.3);
  }
  &::-webkit-scrollbar-track {
    border-radius: 1em;
    background-color: rgba(50, 50, 50, 0.1);
  }
`;

export const rowGap = (gap: string) => css`
  & > *:not(:last-child) {
    margin-right: ${gap};
  }
`;

export const columnGap = (gap: string) => css`
  & > *:not(:last-child) {
    margin-bottom: ${gap};
  }
`;

export const gap = (gap: string) => css`
  ${rowGap(gap)};
  ${rowGap(gap)};
`;
export const wFull = () => css`
  width: 100%;
`;

export const border = (color: string) => css`
  border: 1px solid ${color};
`;
// 自定义行数文本溢出省略
export const multiLineTextOverflow = (line: number) => css`
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: ${line};
  -webkit-box-orient: vertical;
  word-break: break-all;
`;

export const svgColorChange = (color: string, length = '100px') => css`
  transform: translate(-${length});
  filter: drop-shadow(${length} 0 0 ${color});
`;

export const singleLineTextJustify = () => css`
  text-align: justify;
  text-align-last: justify;
`;

export const yaotaiBtnOutLined = ({ withBorderRadius = true }: { withBorderRadius?: boolean }) => css`
  border-radius: ${withBorderRadius ? '4px' : '0px'};
  border-color: var(--primary-color);
  color: var(--primary-color);

  text-align: center;
`;

export const yaotaiBtnFilled = ({ withBorderRadius = true }: { withBorderRadius?: boolean }) => css`
  border-radius: ${withBorderRadius ? '4px' : '0px'};
  background-color: var(--primary-color);
  color: var(--white);
  border: none;
  text-align: center;
`;
